import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { PageLoader } from "./components/page-loader";
import { HomePage } from "./pages/home-page";
import { OrderListPage } from "./pages/order-list-page";
import Navigation from "./components/navigation"
import {ThemeProvider} from "./theme";
import {AppProvider} from "./app-context";

export const App = () => {
    const {isLoading, isAuthenticated} = useAuth0();

    if (isLoading) {
        return (
            <div className="page-layout">
                <PageLoader/>
            </div>
        );
    }

    return (
        <ThemeProvider>
            <AppProvider>
                <Navigation/>
                {isAuthenticated
                    ? <OrderListPage/>
                    : <HomePage/>
                }
            </AppProvider>
        </ThemeProvider>

    )
}
